import React from 'react'
import MediaQuery, { MediaQueryProps } from 'react-responsive'

/**
 * Обертка для MediaQuery, используется для корректного расчета maxWidth
 */
const WithMedia: React.FC<MediaQueryProps> = ({ maxWidth, children, ...mediaProps }) => {
  const px = typeof maxWidth === 'number' ? maxWidth - 1 : maxWidth

  return (
    <MediaQuery maxWidth={px} {...mediaProps}>
      {children}
    </MediaQuery>
  )
}

export default WithMedia
